export const Twitch = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.0364 0H15.9636C7.14712 0 0 7.14713 0 15.9636V16.0364C0 24.8529 7.14712 32 15.9636 32H16.0364C24.8529 32 32 24.8529 32 16.0364V15.9636C32 7.14713 24.8529 0 16.0364 0Z" fill="#6440A4" />
    <path d="M11.0115 7.66626L7.44751 11.2303V24.0592H11.7235V27.6232L15.2875 24.0592H18.1385L24.5535 17.6442V7.66626H11.0115ZM23.1274 16.9312L20.2765 19.7822H17.4254L14.931 22.2766V19.7822H11.7235V9.0912H23.1274V16.9312Z" fill="white" />
    <path d="M20.9884 11.5869H19.5635V15.8628H20.9884V11.5869Z" fill="white" />
    <path d="M17.069 11.5869H15.644V15.8628H17.069V11.5869Z" fill="white" />
  </svg>
)
